module.exports = __webpack_public_path__ + "media/img/pages/profile/bund ger 17-058c72ba397bdab286de331e3e96fcae.webp";